module.exports = __webpack_public_path__ + "static/media/file_type_file.9faaf14f.svg";